var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[{'row': !_vm.noRow}, `col-lg-${_vm.grid.columns} ${_vm.className ? _vm.className : ''}`],style:({ ..._vm.styles, ..._vm.cssVars })},[_vm._l((_vm.fields),function(field){return [_c('componentRenderer',{key:field.id,class:`col-lg-${field.properties.grid.columns}`,attrs:{"field":field},on:{"component-updated":_vm.updated}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }